import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppModule } from '../../app.module';
import { WhatsappMessage } from '../../models/whatsapp';
import { SocketMessageType } from '../../models/websocket';
import { SharedDataService } from '../../shared/shareddata.service';
import { Router } from '@angular/router';
import { IncidentService } from '../../shared/incident.service';
import { WhatsappService } from '../whatsapp.service';
import { Incident, IncidentLocation, IncidentSearchRequest } from '../../models/incident';
import { NotificationService } from '../../shared/notification.service';
import { TyreLocation } from '../../shared/enums';
import { map, of, switchMap } from 'rxjs';
import { mediaInfo } from '../../shared/media';
import { messageCaption, messageDocument } from '../whatsapp-media';

@Component({
  selector: 'app-wa-message',
  imports: [AppModule],
  templateUrl: './wa-message.html',
  styleUrl: './wa-message.less'
})
export class WaMessage {

  @Input() message: WhatsappMessage;

  public get attachment() { return mediaInfo(messageDocument(this.message) || { url: this.message.docUrl, mimeType: this.message.mimeType, mediaKind: this.message.mediaKind }); }
  public get attachmentName() { return messageDocument(this.message)?.description || 'Attachment'; }
  public get caption() { return messageCaption(this.message); }

  public socketMessageType = SocketMessageType;
  public isSearchForIncidentModalVisible: boolean = false;
  public incidentSearchRequest: IncidentSearchRequest;
  public dateRange: [Date, Date] | null = null;
  public isSearchingForIncident: boolean = false;
  public incidentSearchResults: Incident[] = [];

  @Output() messageRemoved = new EventEmitter<WhatsappMessage>();

  constructor(public sharedDataService: SharedDataService,
    private router: Router,
    private incidentService: IncidentService,
    public whatsappService: WhatsappService,
    public notification: NotificationService
  ) {
    //this.message.date = this.message.date;
    
  }

  public onClickCreateNewIncident() {
    if (!this.sharedDataService.selectedMessages || this.sharedDataService.selectedMessages.length === 0) {
      this.sharedDataService.selectedMessages = [this.message];
      //this.sharedDataService.isWhatsappDrawerVisible = false;
      this.router.navigate(['/incident/new']);
    }
    else {
      //add to current selected messages
      if (!this.sharedDataService.selectedMessages.find(msg => msg.whatsappMessageId === this.message.whatsappMessageId)) {
        //merge object
        this.sharedDataService.selectedMessages.push(this.message);
        //send update
        let incident = new Incident();
        if (this.message.messageType === SocketMessageType.IncidentLocationUpdate) {
          incident.location = JSON.parse(this.message.extendedObject!) as IncidentLocation;
        }
        else if (this.message.messageType === SocketMessageType.WhatsappIncident) {
          incident = JSON.parse(this.message.extendedObject!) as Incident;
        }
        this.incidentService.emitIncidentUpdate(incident);
      }
    }
  }

  private mergeIncomingIncident(incident: Incident, incomingIncident: Incident): Incident {
      console.log("Going to merge", incident);
      
  
  
      // Merge basic fields
      if (!incident.clientId && incomingIncident.clientId) {
        incident.clientId = incomingIncident.clientId;
      }
      if (!incident.clientName && incomingIncident.clientName) {
        incident.clientName = incomingIncident.clientName;
      }
      if (!incident.incidentDescription && incomingIncident.incidentDescription) {
        incident.incidentDescription = incomingIncident.incidentDescription;
      }
      
      incident.incidentType = incomingIncident.incidentType;
      
      if (!incident.fleetVehicleOdoReading && incomingIncident.fleetVehicleOdoReading) {
        incident.fleetVehicleOdoReading = incomingIncident.fleetVehicleOdoReading;
      }
  
      // Merge driver information
      if (incomingIncident.driver) {
        if (!incident.driver.driverId && incomingIncident.driver.driverId) {
          incident.driver.driverId = incomingIncident.driver.driverId;
        }
        if ((!incident.driver.name || incident.driver.name.trim() === '') && incomingIncident.driver.name) {
          incident.driver.name = incomingIncident.driver.name;
        }
        if (!incident.driver.phoneNumber && incomingIncident.driver.phoneNumber) {
          incident.driver.phoneNumber = incomingIncident.driver.phoneNumber;
        }
      }
  
      // Merge fleet vehicle information
      if (incomingIncident.fleetVehicle) {
        if (!incident.fleetVehicle.vehicleId && incomingIncident.fleetVehicle.vehicleId) {
          incident.fleetVehicle.vehicleId = incomingIncident.fleetVehicle.vehicleId;
        }
        if (!incident.fleetVehicle.registrationNumber && incomingIncident.fleetVehicle.registrationNumber) {
          incident.fleetVehicle.registrationNumber = incomingIncident.fleetVehicle.registrationNumber;
        }
        if (!incident.fleetVehicle.vinNumber && incomingIncident.fleetVehicle.vinNumber) {
          incident.fleetVehicle.vinNumber = incomingIncident.fleetVehicle.vinNumber;
        }
      }
  
      // Merge location information
      if (incomingIncident.location) {
        if (!incident.location.latitude && incomingIncident.location.latitude) {
          incident.location.latitude = incomingIncident.location.latitude;
        }
        if (!incident.location.longitude && incomingIncident.location.longitude) {
          incident.location.longitude = incomingIncident.location.longitude;
        }
        if (!incident.location.description && incomingIncident.location.description) {
          incident.location.description = incomingIncident.location.description;
        }
        if (!incident.location.descriptionShort && incomingIncident.location.descriptionShort) {
          incident.location.descriptionShort = incomingIncident.location.descriptionShort;
        }
      }
  
      // Merge tyre positions if current is empty or default
      if (incomingIncident.tyrePositions && incomingIncident.tyrePositions.length > 0 && incomingIncident.tyrePositions[0].tyreLocation && incomingIncident.tyrePositions[0].tyreNumber && incomingIncident.tyrePositions[0].size) {
        const hasOnlyDefaultTyre = incident.tyrePositions.length === 1 && 
                                   incident.tyrePositions[0].tyreLocation === TyreLocation.trailer &&
                                   incident.tyrePositions[0].tyreNumber === 0;
        if (incident.tyrePositions.length === 0 || hasOnlyDefaultTyre) {
          incident.tyrePositions = incomingIncident.tyrePositions;
        }
      }
  
      // Merge tyre brands if current has only default value
      if (incomingIncident.tyreBrands && incomingIncident.tyreBrands.length > 0) {
        const hasOnlyDefaultBrand = incident.tyreBrands.length === 1 && incident.tyreBrands[0] === -1;
        if (hasOnlyDefaultBrand) {
          incident.tyreBrands = incomingIncident.tyreBrands;
        }
      }
  
  
      console.log("Merged incoming incident into current incident:", incident);
      return incident;
    }


public onClickLinkToCurrentOpen() {
  this.sharedDataService.selectedMessages = [];

  this.incidentService.assignWhatsappMessageToIncident(
    this.whatsappService.currentIncidentId()!, this.message.whatsappMessageId
  ).pipe(
    switchMap(incident => this.caption
      ? this.incidentService.decodeIncidentMessage(this.caption).pipe(
        map(decoded => ({ incident, decoded }))
      )
      : of({ incident, decoded: null })
    ),
    switchMap(({ incident, decoded }) => {
      // Enrich with CCS-decoded fields
      if (!decoded) return of(incident);
      incident = this.mergeIncomingIncident(incident, decoded);
      // Append raw message text to description
      // incident.incidentDescription = 
      //   (incident.incidentDescription ? incident.incidentDescription + '\n' : '') 
      //   + this.message.message;
      return this.incidentService.updateIncident(incident);
    })
  ).subscribe({
    next: (incident) => {
      this.incidentService.updateOrAddIncidentToList(incident);
      this.notification.showSuccess('Message assigned and details extracted successfully.');
      this.router.navigate([`/incident/${incident.incidentId}`]);
      this.whatsappService.changeMessageIncident(
        this.message.whatsappMessageId, incident.incidentId!, incident.incidentNumber!
      );
    },
    error: (error) => {
      this.notification.handleError(error, 'Error assigning message to breakdown');
    }
  });
}

  public onCancelSearch() {
    this.isSearchForIncidentModalVisible = false;
    this.incidentSearchRequest = {
      closedIncidents: false,
      startDate: '',
      endDate: '',
      incidentNumber: ''
    };
    this.dateRange = null;
  }

  
  public onDateRangeChange(dateRange: [Date, Date] | null) {
    this.dateRange = dateRange;
    if (dateRange && dateRange.length === 2) {
      this.incidentSearchRequest.startDate = dateRange[0].toISOString();
      this.incidentSearchRequest.endDate = dateRange[1].toISOString();
    } else {
      this.incidentSearchRequest.startDate = '';
      this.incidentSearchRequest.endDate = '';
    }
  }

  public onSearchIncident() {
    this.isSearchingForIncident = true;
    this.incidentService.searchForIncidents(this.incidentSearchRequest).subscribe({
      next: (results: Incident[]) => {
        this.incidentSearchResults = results;
        this.isSearchingForIncident = false;
      },
      error: (error) => { 
        this.notification.handleError(error, 'Error searching for breakdowns');
        this.isSearchingForIncident = false;
      }
    });
  }

  
public onSelectIncident(incident: Incident) {
  this.isSearchForIncidentModalVisible = false;
  this.sharedDataService.selectedMessages = [];
  this.sharedDataService.isWhatsappDrawerVisible = false;

  this.incidentService.assignWhatsappMessageToIncident(incident.incidentId, this.message.whatsappMessageId).pipe(
    switchMap(incident =>
      this.caption
        ? this.incidentService.decodeIncidentMessage(this.caption).pipe(
            map(decoded => ({ incident, decoded }))
          )
        : of({ incident, decoded: null })
    ),
    switchMap(({ incident, decoded }) => {
      if (!decoded) return of(incident);
      if (decoded) {
        incident = this.mergeIncomingIncident(incident, decoded);
      }
      if (this.caption) {
        incident.incidentDescription =
          (incident.incidentDescription ? incident.incidentDescription + '\n' : '')
          + this.caption;
      }
      return this.incidentService.updateIncident(incident);
    })
  ).subscribe({
    next: (incident) => {
      this.incidentService.updateOrAddIncidentToList(incident);
      this.notification.showSuccess('Message assigned and details extracted successfully.');
      this.whatsappService.changeMessageIncident(this.message.whatsappMessageId, incident.incidentId!, incident.incidentNumber!);
      if (!this.whatsappService.currentIncidentId()) {
        this.router.navigate([`/incident/${incident.incidentId}`]);
      }
    },
    error: (error) => {
      this.notification.handleError(error, 'Error assigning message to breakdown');
    }
  });
}

  public onClickAddToIncident() {
    this.isSearchForIncidentModalVisible = true;
      // this.selectedWhatsappMessageId = this.sharedDataService.messageAsObject(msg).whatsappMessageId;
    this.incidentSearchRequest = {
      closedIncidents: false,
      startDate: '',
      endDate: '',
      incidentNumber: ''
    };
    this.onSearchIncident();
    }

  public onClickRemoveMessage() {
    this.messageRemoved.emit(this.message);
  }

  public onClickViewIncident() {
    let incidentLoc = JSON.parse(this.message.extendedObject!) as IncidentLocation;
    if (incidentLoc.incidentId) {
      this.router.navigate([`/incident/${incidentLoc.incidentId}`]);
      this.message.incidentId = incidentLoc.incidentId; //should remove from list?
    }
    else {
      this.notification.showWarning('No breakdown linked to this message');
    }
    
  }

  public isItThisIncident() : boolean {
    let incidentLoc = JSON.parse(this.message.extendedObject!) as IncidentLocation;
    return incidentLoc.incidentId === this.whatsappService.currentIncidentId();
  }
}
